<template>
    <div>
        <div v-if="showTimer">
            <p>{{ $t('Resend link will be available in') }} {{ countdown }} {{ $t('seconds')}}</p>
        </div>

        <div v-else>
            {{ $t('Didn\'t get the code? ') }}
            <a href="javascript:void(0)" class="theme-color fw-bold" @click="reSendsms">{{ $t('Resend It')}}</a>
        </div>
    </div>
</template>

<script>
import { useToast } from "vue-toastification";
const toast = useToast();
export default {
    data() {
        return {
            showTimer: false,
            countdown: 60
        };
    },
    created() {
        if(this.showTimer === true){
            this.startTimer();
        }
    },
    methods: {
        startTimer() {
            this.showTimer = true;
            this.countdown = 60;
            this.countdownInterval = setInterval(() => {
                if (this.countdown > 0) {
                    this.countdown--;
                } else {
                    clearInterval(this.countdownInterval);
                    this.showTimer = false;
                }
            }, 1000);
        },
        reSendsms() {
            this.startTimer();
            const toastId = toast.info(this.$t('sending ...'), { icon: 'fa-regular fa-comment-dots' });
            let errorToastId; // Declare the variable outside the if conditions

            axios.post('resend_activation_code').then(response => {
                toast.dismiss(toastId);
                console.log(response.data);
                const successToastId = toast.success(response.data.message, { icon: 'fa-solid fa-trash-arrow-up' });
            }).catch(error => {
                console.error(error);
                toast.dismiss(toastId);
                if (error.response && error.response.data && error.response.data.message) {
                     errorToastId = toast.error(error.response.data.message, { icon: 'fa-solid fa-exclamation-circle' });
                } else {
                     errorToastId = toast.error('حدث خطأ أثناء الإرسال', { icon: 'fa-solid fa-exclamation-circle' });
                }
                setTimeout(() => {
                    toast.dismiss(errorToastId);
                }, 3000);
            });

        }
    },
    beforeDestroy() {
        if (this.countdownInterval) {
            clearInterval(this.countdownInterval);
        }
    }
};
</script>
